import { useEffect, useState } from "react";
import Home from "./Home";

const ServisorRedirect = () => {
  const [redirectFailed, setRedirectFailed] = useState(false);

  const prod_host = "consumer.servisor.co.za";

  const redirect_host = "https://www.servisor.co.za";

  const getHostName = window.location.hostname;

  const redirectService = () => {
    if (getHostName === prod_host) {
      window.location.replace(redirect_host);

      const timer = setTimeout(() => {
        setRedirectFailed(true);
      }, 2000);
      return () => {
        clearTimeout(timer);
      };
    } else {
      setRedirectFailed(true);
    }
  };

  useEffect(() => {
    redirectService();
  }, []);

  if (redirectFailed) {
    return <Home />;
  }

  return null;
};

export default ServisorRedirect;

